import { render, staticRenderFns } from "./laout.vue?vue&type=template&id=30c44702&scoped=true"
import script from "./laout.vue?vue&type=script&lang=js"
export * from "./laout.vue?vue&type=script&lang=js"
import style0 from "./laout.vue?vue&type=style&index=0&id=30c44702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c44702",
  null
  
)

export default component.exports